import { gql } from '@apollo/client'

export const IS_CULTIVATING_TALENTS_ENABLED = gql`
  query IsCultivatingTalentsEnabledForCompanyAndCountry($companyId: HashedId!, $country: Country!) {
    isCultivatingTalentsEnabledForCompanyAndCountry(companyId: $companyId, country: $country)
  }
`

export const IS_RANKING_ENABLED = gql`
  query IsRankingEnabledForCompanyAndCountry($companyId: HashedId!, $country: Country!) {
    isRankingEnabledForCompanyAndCountry(companyId: $companyId, country: $country)
  }
`

export const EMPLOYEES_AND_TAGS_WITH_RANKING_DISABLED = gql`
  query EmployeesAndTagsWithRankingDisabled($companyId: HashedId!, $country: Country!) {
    employeesAndTagsWithRankingDisabled(companyId: $companyId, country: $country) {
      id
      firstName
      lastName
      currentLevel
      avatarUrl
      buName
      companyName
      tags {
        id
        type
        addedDate
        removedDate
        note
      }
    }
  }
`

export const TALENTS_SEASON_YEARS = gql`
  query FindTalentsSeasonsYears($companyId: HashedId!, $country: Country!) {
    findTalentsSeasonsYears(companyId: $companyId, country: $country) {
      companyId
      country
      year
      talentsSeasonId
      talentsSeasonStatus
    }
  }
`

export const LIVE_BOARD_OR_HISTORY = gql`
  query LiveBoardOrHistory($companyId: HashedId!, $country: Country!, $year: Int!) {
    liveBoardOrHistory(companyId: $companyId, country: $country, year: $year) {
      id
      assessable
      rank
      previousCompanyRankData {
        employeeId
        companyName
        rank
        total
      }
      previousRank
      employee {
        id
        firstName
        lastName
        avatarUrl
        currentLevel
        buName
      }
      evaluation
      latestEvaluation
      draftEvaluation
      tags {
        id
        type
        addedDate
        removedDate
        note
        globalId
      }
    }
  }
`

export const IMPORT_EXCEL = gql`
  query ImportExcelData($companyId: HashedId!, $country: Country!, $year: Int!, $excelData: [ExcelDataInput!]!) {
    importExcel(companyId: $companyId, country: $country, year: $year, excelData: $excelData) {
      id
      assessable
      rank
      previousRank
      employee {
        id
        firstName
        lastName
        avatarUrl
        currentLevel
        buName
      }
      evaluation
      draftEvaluation
      latestEvaluation
      tags {
        id
        globalId
        type
        addedDate
        removedDate
        note
      }
    }
  }
`

export const TALENTS_SEASON_SETTINGS = gql`
  query TalentsSeasonSettings($companyId: HashedId!, $country: Country!, $year: Int!) {
    talentsSeasonSettings(companyId: $companyId, country: $country, year: $year) {
      talentsSeasonId
      companyId
      country
      year
      talentsSeasonStatus
      lowPercentage
      topPercentage
      blockedChangesForLow
      closingDate
      confirmationDate
      closingEmployee {
        id
        firstName
        lastName
        avatarUrl
      }
      confirmationEmployee {
        id
        firstName
        lastName
        avatarUrl
      }
    }
  }
`
